import { useEffect } from 'react';

export default function Home() {
    useEffect(() => {
        // Redirect to GeekTickets main website
        window.location.href = 'https://geektickets.ie';
    }, []);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <p className="text-muted-foreground">Redirecting to GeekTickets...</p>
        </div>
    );
}
